import React, {Component} from 'react';
import Styles from './style.css';
import {Link} from 'react-router-dom';
import {dataRegister} from "../../services/dataRegister";
import HeaderHomeOne from "../../components/header-home-one/component"
import {BeatLoader} from 'react-spinners';
import Typist from 'react-typist';
import {cartRegister} from "../../services/cartRegister";
import {imagesRegister} from "../../services/imagesRegister";
import {quotesRegister} from "../../services/quotesRegister";
import {langRegister} from "../../services/langRegister";
import Footer from "../../components/footer/component";
import AnimateHeight from 'react-animate-height';
import cx from 'classnames'
import {marketRegister} from "../../services/marketRegister";
import HomeSectionsEight from "../../components/home-sections/eight/component";
import HomeSectionsTwelve from "../../components/home-sections/twelve/component";
import HomeSectionsEleven from "../../components/home-sections/eleven/component";
import HomeSectionsNine from "../../components/home-sections/nine/component";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import ModalLeave from "../../components/modal-leave/component";
import ModalVideo from "../../components/modal-video/component";
import ModalKeyword from "../../components/modal-keyword/component";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {scroller, Element} from 'react-scroll'
import queryString from "query-string";


class Home extends Component {

    constructor(props) {
        super(props);
        this.state = {
            market: null,
            industries: [],
            dropdown: false,
            dropdown_second: false,
            search: "",
            search_second: "",
            isLoading: true,
            accordion: [],
            icon: 0,
            video: false
        };
        this._setKeyword = this._setKeyword.bind(this);
    };

    componentWillMount() {
        window.scrollTo(0, 0);
        this._updateData();
        this._resetSignUp();
        this._updateAccordion();
        this._setVideo = this._setVideo.bind(this);

        //GOOGLE ANALYTICS
        if(this.platformLive()){
            ReactGA.pageview('/');
            ReactGA4.send({ hitType: "pageview", page: "/" });
        }

        //FACEBOOK PIXEL
        if(this.platformLive()){
            ReactPixel.pageView();
        }
    }

    componentDidMount() {
        this._scrollView();
        this._initIcons();
    }

    _updateData() {
        let market = marketRegister.get();
        this.setState({market: market}, () => {
            cartRegister.setMarket(salesChannelRegister.get("market"));
            cartRegister.setLang(langRegister.lang());
            this._updateIndustries(salesChannelRegister.get("market"), langRegister.lang(), "");
        });
    }

    _updateAccordion() {

        let accordion = [
            {
                title: langRegister.get("faq", "item_1"),
                text: langRegister.get("faq", "item_2"),
                height: 0
            }, {
                title: langRegister.get("faq", "item_3"),
                text: langRegister.get("faq", "item_4"),
                height: 0
            }, {
                title: langRegister.get("faq", "item_5"),
                text: langRegister.get("faq", "item_6"),
                height: 0
            }, {
                title: langRegister.get("faq", "item_7"),
                text: langRegister.get("faq", "item_8"),
                height: 0
            }, {
                title: langRegister.get("faq", "item_9"),
                text: langRegister.get("faq", "item_10"),
                height: 0
            }, {
                title: langRegister.get("faq", "item_11"),
                text: langRegister.get("faq", "item_12"),
                height: 0
            }, {
                title: langRegister.get("faq", "item_13"),
                text: langRegister.get("faq", "item_14"),
                height: 0
            },
            {
                title: langRegister.get("faq", "item_15"),
                text: langRegister.get("faq", "item_16"),
                height: 0
            }, {
                title: langRegister.get("faq", "item_17"),
                text: langRegister.get("faq", "item_18"),
                height: 0
            }, {
                title: langRegister.get("faq", "item_19"),
                text: langRegister.get("faq", "item_20"),
                height: 0
            }, {
                title: langRegister.get("faq", "item_21"),
                text: langRegister.get("faq", "item_22"),
                height: 0
            }, {
                title: langRegister.get("faq", "item_23"),
                text: langRegister.get("faq", "item_24"),
                height: 0
            }, {
                title: langRegister.get("faq", "item_25"),
                text: langRegister.get("faq", "item_26"),
                height: 0
            }, {
                title: langRegister.get("faq", "item_27"),
                text: langRegister.get("faq", "item_28"),
                height: 0
            }, {
                title: langRegister.get("faq", "item_29"),
                text: langRegister.get("faq", "item_30"),
                height: 0
            }, {
                title: langRegister.get("faq", "item_31"),
                text: langRegister.get("faq", "item_32"),
                height: 0
            }, {
                title: langRegister.get("faq", "item_33"),
                text: langRegister.get("faq", "item_34"),
                height: 0
            }, {
                title: langRegister.get("faq", "item_35"),
                text: langRegister.get("faq", "item_36"),
                height: 0
            }, {
                title: langRegister.get("faq", "item_37"),
                text: langRegister.get("faq", "item_38"),
                height: 0
            }, {
                title: langRegister.get("faq", "item_39"),
                text: langRegister.get("faq", "item_40"),
                height: 0
            }, {
                title: langRegister.get("faq", "item_41"),
                text: langRegister.get("faq", "item_42"),
                height: 0
            }, {
                title: langRegister.get("faq", "item_43"),
                text: langRegister.get("faq", "item_44"),
                height: 0
            }, {
                title: langRegister.get("faq", "item_45"),
                text: langRegister.get("faq", "item_46"),
                height: 0
            }, {
                title: langRegister.get("faq", "item_47"),
                text: langRegister.get("faq", "item_48"),
                height: 0
            }, {
                title: langRegister.get("faq", "item_49"),
                text: langRegister.get("faq", "item_50"),
                height: 0
            }, {
                title: langRegister.get("faq", "item_51"),
                text: langRegister.get("faq", "item_52"),
                height: 0
            },
            , {
                title: langRegister.get("faq", "item_53"),
                text: langRegister.get("faq", "item_54"),
                height: 0
            }, {
                title: langRegister.get("faq", "item_55"),
                text: langRegister.get("faq", "item_56"),
                height: 0
            }
        ];

        this.setState({accordion: accordion});
    }

    _updateIndustries(market, lang, search) {
        dataRegister.getIndustries(market, lang, search, 50).then((response) => {
            this.setState({industries: response, isLoading: false});
        }, (error) => {
            console.log(error);
        });
    }

    _initIcons() {
        setInterval(() => {
            this.state.icon = this.state.icon + 1;
            if (this.state.icon > 3) {
                this.state.icon = 0;
            }
            this.setState({icon: this.state.icon});
        }, 5000);
    }

    _setIcon(value) {
        this.setState({icon: value});
    }

    _resetSignUp() {
        cartRegister.remove();
        quotesRegister.remove();
        imagesRegister.remove();
        quotesRegister.setView(null);
    }

    _scrollView() {
        try {
            let element = this.props.match.params.item;
            //this.props.history.replace("/");
            this._scrollTo(element);
        } catch (e) {
        }
    }

    _selectIndustry(prop) {
        try {
            this.refs.searchIndustry.blur();
        } catch (e) {
        }
        let url_object = {industry: JSON.stringify(prop)};
        let query = queryString.stringify(url_object);
        if (dataRegister.api.primehit.indexOf("https://api.devprimehit") !== -1) {
            window.open("https://app.devadbop.com/" + marketRegister.code() + "/" + langRegister.lang() + "/adbop?" + query, '_blank');
        } else {
            window.open("https://app.adbop.com/" + marketRegister.code() + "/" + langRegister.lang() + "/adbop?" + query, '_blank');
        }
    }

    _lisIndustries() {
        if (dataRegister.api.primehit.indexOf("https://api.devprimehit") !== -1) {
            window.open("https://app.devadbop.com/" + marketRegister.code() + "/" + langRegister.lang() + "/adbop/signup/industry", '_blank');
        } else {
            window.open("https://app.adbop.com/" + marketRegister.code() + "/" + langRegister.lang() + "/adbop/signup/industry", '_blank');
        }
    }

    _filterIndustries(search) {
        let industries = [];
        let exact = [];
        let first = [];
        let contains = [];
        let pattern = new RegExp('^' + search.toLowerCase());
        for (let i = 0; i < this.state.industries.length; i++) {
            if (this.state.industries[i].name.toLowerCase() === search.toLowerCase()) {
                exact.push(this.state.industries[i]);
            } else if (this.state.industries[i].name.toLowerCase().indexOf(search.toLowerCase()) !== 1 && !pattern.test(this.state.industries[i].name.toLowerCase())) {
                contains.push(this.state.industries[i]);
            } else if (pattern.test(this.state.industries[i].name.toLowerCase())) {
                first.push(this.state.industries[i]);
            }
        }
        industries = exact.concat(first, contains);
        return industries;
    }

    _setVideo(value) {
        this.setState({video: value});
    }

    _setKeyword(keyword) {
        if (keyword) {
            this.setState({keyword: false, search: ""});
        } else {
            this.setState({keyword: false});
        }
    }

    _scrollTo(element) {
        let offSet = 0, timeout = null;
        element = document.getElementById(element);
        if (element) {
            const elemPos = element ? element.getBoundingClientRect().top + window.pageYOffset : 0;
            window.scroll({top: elemPos + offSet, left: 0, behavior: 'smooth'});
        }
    }

    _renderText(item) {
        return langRegister.get("home", item);
    }

    platformLive() {
        try {
            return window.location.hostname.indexOf('dev') === -1;
        } catch (e) {
            return false
        }
    }

    render() {
        return (
            <div className={Styles.view}>
                {
                    false &&
                    <a className={Styles.whatsappButton} href="https://wa.me/+46731214608">
                        <img className={Styles.whatsappButtonImage} src={require('../../assets/images/whatsapp_button.png')}/>
                    </a>
                }
                {
                    this.state.video &&
                    <ModalVideo setVideo={this._setVideo} props={this.props}/>
                }
                {
                    this.state.keyword &&
                    <ModalKeyword initKeyword={this.state.search} setKeyword={this._setKeyword} props={this.props}/>
                }
                <HeaderHomeOne props={this.props}/>
                <Element name="top" className="top"></Element>
                <div className={Styles.header}>
                    <img className={Styles.figureOne} src={require("../../assets/images/figure-one-new.png")}/>
                    <img className={Styles.figureTwo} src={require("../../assets/images/figure-six.png")}/>
                    <img className={Styles.figureMobileOne} src={require("../../assets/images/figure_mobile_one.png")}/>
                    <div className={Styles.container}>
                        <div className={Styles.sectionOne}>
                            <div className={Styles.sectionOneLeft}>
                                <img className={
                                    cx(Styles.phone,
                                        {
                                            [Styles.phoneVisible]: this.state.icon === 0,
                                            [Styles.phoneVisibleInUp]: this.state.icon === 0,
                                        })
                                } src={require("../../assets/images/mobile_header/AB_iPhoneX_Google.png")}/>
                                <img className={
                                    cx(Styles.phone,
                                        {
                                            [Styles.phoneVisible]: this.state.icon === 1,
                                            [Styles.phoneVisibleInUp]: this.state.icon === 1,
                                        })
                                } src={require("../../assets/images/mobile_header/AB_iPhoneX_Facebook.png")}/>
                                <img className={
                                    cx(Styles.phone,
                                        {
                                            [Styles.phoneVisible]: this.state.icon === 2,
                                            [Styles.phoneVisibleInUp]: this.state.icon === 2,
                                        })
                                } src={require("../../assets/images/mobile_header/AB_iPhoneX_Bing.png")}/>
                                <img className={
                                    cx(Styles.phone,
                                        {
                                            [Styles.phoneVisible]: this.state.icon === 3,
                                            [Styles.phoneVisibleInUp]: this.state.icon === 3,
                                        })
                                } src={require("../../assets/images/mobile_header/AB_iPhoneX_Instagram.png")}/>
                            </div>
                            <div className={Styles.sectionOneRight}>
                                <img onClick={() => this._setVideo(true)}
                                     className={Styles.sectionOneRightPlayButtonMobile}
                                     src={require("../../assets/images/play_button_mobile.svg")}/>
                                <div className={Styles.sectionOneRightTitle}>
                                    <div className={Styles.bold}>
                                        {this._renderText("item_1")}&nbsp;
                                    </div>
                                    <span>{this._renderText("item_2")}&nbsp;</span>
                                    <span>{this._renderText("item_3")}</span>
                                    <div className={Styles.sectionOneRightTitleIcons}>
                                        <div onClick={() => this._setIcon(0)} className={
                                            cx(Styles.sectionOneRightTitleIconsBox,
                                                {
                                                    [Styles.sectionOneRightTitleIconsBoxActive]: this.state.icon === 0,
                                                })
                                        }>
                                            <img className={Styles.sectionOneRightTitleIconsBoxGoogle}
                                                 src={require("../../assets/images/google_logo_icon.svg")}/>
                                        </div>
                                        <div onClick={() => this._setIcon(1)} className={
                                            cx(Styles.sectionOneRightTitleIconsBox,
                                                {
                                                    [Styles.sectionOneRightTitleIconsBoxActive]: this.state.icon === 1,
                                                })
                                        }>
                                            <img className={Styles.sectionOneRightTitleIconsBoxFb}
                                                 src={require("../../assets/images/facebook_logo_icon.svg")}/>
                                        </div>
                                        <div onClick={() => this._setIcon(2)} className={
                                            cx(Styles.sectionOneRightTitleIconsBox,
                                                {
                                                    [Styles.sectionOneRightTitleIconsBoxActive]: this.state.icon === 2,
                                                })
                                        }>
                                            <img className={Styles.sectionOneRightTitleIconsBoxBing}
                                                 src={require("../../assets/images/bing_logo_icon.svg")}/>
                                        </div>
                                        <div onClick={() => this._setIcon(3)} className={
                                            cx(Styles.sectionOneRightTitleIconsBox,
                                                {
                                                    [Styles.sectionOneRightTitleIconsBoxActive]: this.state.icon === 3,
                                                })
                                        }>
                                            <img className={Styles.sectionOneRightTitleIconsBoxInstagram}
                                                 src={require("../../assets/images/instagram_logo_icon.svg")}/>
                                        </div>
                                    </div>
                                </div>
                                <div className={Styles.sectionOneRightSubtitle}>
                                    <div className={Styles.sectionOneRightSubtitleText}>
                                        {this._renderText("item_4")}&nbsp;
                                    </div>
                                    <div className={Styles.sectionOneRightSubtitleTextBold}>
                                        <Typist stdTypingDelay={5} cursor={{show: false}}>
                                            {this._renderText("item_5")}
                                            <Typist.Backspace count={this._renderText("item_5").length} delay={2000}/>
                                            {this._renderText("item_8")}
                                            <Typist.Backspace count={this._renderText("item_8").length} delay={2000}/>
                                            {this._renderText("item_9")}
                                            <Typist.Backspace count={this._renderText("item_9").length} delay={2000}/>
                                            {this._renderText("item_71")}
                                            <Typist.Backspace count={this._renderText("item_71").length} delay={2000}/>
                                            {this._renderText("item_5")}
                                            <Typist.Backspace count={this._renderText("item_5").length} delay={2000}/>
                                            {this._renderText("item_8")}
                                            <Typist.Backspace count={this._renderText("item_8").length} delay={2000}/>
                                            {this._renderText("item_9")}
                                            <Typist.Backspace count={this._renderText("item_9").length} delay={2000}/>
                                            {this._renderText("item_71")}
                                            <Typist.Backspace count={this._renderText("item_71").length} delay={2000}/>
                                            {this._renderText("item_5")}
                                            <Typist.Backspace count={this._renderText("item_5").length} delay={2000}/>
                                            {this._renderText("item_8")}
                                            <Typist.Backspace count={this._renderText("item_8").length} delay={2000}/>
                                            {this._renderText("item_9")}
                                            <Typist.Backspace count={this._renderText("item_9").length} delay={2000}/>
                                            {this._renderText("item_71")}
                                            <Typist.Backspace count={this._renderText("item_71").length} delay={2000}/>
                                            {this._renderText("item_5")}
                                            <Typist.Backspace count={this._renderText("item_5").length} delay={2000}/>
                                            {this._renderText("item_8")}
                                            <Typist.Backspace count={this._renderText("item_8").length} delay={2000}/>
                                            {this._renderText("item_9")}
                                            <Typist.Backspace count={this._renderText("item_9").length} delay={2000}/>
                                            {this._renderText("item_71")}
                                            <Typist.Backspace count={this._renderText("item_71").length} delay={2000}/>
                                            {this._renderText("item_5")}
                                            <Typist.Backspace count={this._renderText("item_5").length} delay={2000}/>
                                            {this._renderText("item_8")}
                                            <Typist.Backspace count={this._renderText("item_8").length} delay={2000}/>
                                            {this._renderText("item_9")}
                                            <Typist.Backspace count={this._renderText("item_9").length} delay={2000}/>
                                            {this._renderText("item_71")}
                                            <Typist.Backspace count={this._renderText("item_71").length} delay={2000}/>
                                            {this._renderText("item_5")}
                                            <Typist.Backspace count={this._renderText("item_5").length} delay={2000}/>
                                            {this._renderText("item_8")}
                                            <Typist.Backspace count={this._renderText("item_8").length} delay={2000}/>
                                            {this._renderText("item_9")}
                                            <Typist.Backspace count={this._renderText("item_9").length} delay={2000}/>
                                            {this._renderText("item_71")}
                                            <Typist.Backspace count={this._renderText("item_71").length} delay={2000}/>
                                            {this._renderText("item_5")}
                                            <Typist.Backspace count={this._renderText("item_5").length} delay={2000}/>
                                            {this._renderText("item_8")}
                                            <Typist.Backspace count={this._renderText("item_8").length} delay={2000}/>
                                            {this._renderText("item_9")}
                                            <Typist.Backspace count={this._renderText("item_9").length} delay={2000}/>
                                            {this._renderText("item_71")}
                                            <Typist.Backspace count={this._renderText("item_71").length} delay={2000}/>
                                            {this._renderText("item_5")}
                                            <Typist.Backspace count={this._renderText("item_5").length} delay={2000}/>
                                            {this._renderText("item_8")}
                                            <Typist.Backspace count={this._renderText("item_8").length} delay={2000}/>
                                            {this._renderText("item_9")}
                                            <Typist.Backspace count={this._renderText("item_9").length} delay={2000}/>
                                            {this._renderText("item_71")}
                                            <Typist.Backspace count={this._renderText("item_71").length} delay={2000}/>
                                            {this._renderText("item_5")}
                                            <Typist.Backspace count={this._renderText("item_5").length} delay={2000}/>
                                            {this._renderText("item_8")}
                                            <Typist.Backspace count={this._renderText("item_8").length} delay={2000}/>
                                            {this._renderText("item_9")}
                                            <Typist.Backspace count={this._renderText("item_9").length} delay={2000}/>
                                            {this._renderText("item_71")}
                                            <Typist.Backspace count={this._renderText("item_71").length} delay={2000}/>
                                            {this._renderText("item_5")}
                                        </Typist>
                                    </div>
                                </div>
                                <div className={Styles.sectionOneRightIndustry}>
                                    <input id={"industry_input"}
                                           maxLength={30}
                                           disabled={this.state.isLoading}
                                           onFocus={() => {
                                               this.setState({dropdown: true});
                                               //this._scrollTo("industry_input")
                                               scroller.scrollTo('top', {
                                                   duration: 600,
                                                   delay: 0,
                                                   offset: 170,
                                                   smooth: 'easeInOutQuart'
                                               })
                                           }}
                                           onBlur={() => this.setState({dropdown: false})}
                                           value={this.state.search}
                                           ref='searchIndustry'
                                        //onChange={(event) => this.setState({search: event.target.value})}
                                           onChange={(event) => {
                                               this.setState({search: event.target.value}, () => {
                                                   this._updateIndustries(salesChannelRegister.get("market"), langRegister.lang(), this.state.search);
                                               })
                                           }}
                                           placeholder={this._renderText("item_6")}
                                           className={Styles.sectionOneRightIndustryInput}/>
                                    <div onClick={() => {
                                        this._lisIndustries()
                                    }} className={Styles.inputContainerListButton}>
                                        <img className={Styles.inputContainerListButtonIcon}
                                             src={require("../../assets/images/list_icon.svg")}/>
                                    </div>
                                    <div
                                        onClick={() => this._lisIndustries()}
                                        className={Styles.sectionOneRightIndustryButton}>
                                        {
                                            !this.state.isLoading &&
                                            <div>{this._renderText("item_7")}</div>
                                            ||
                                            <BeatLoader size={9} color={'#ffffff'} loading={true}/>
                                        }
                                    </div>
                                    {
                                        this.state.dropdown && !this.state.isLoading &&
                                        <div className={Styles.sectionOneRightIndustryDropdown}>
                                            {
                                                this._filterIndustries(this.state.search).filter((item) => {
                                                    return item.name.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                                }).map((prop, i) => {
                                                    return (
                                                        <div key={i} onMouseDown={() => this._selectIndustry(prop)}
                                                             className={Styles.sectionOneRightIndustryDropdownItem}>
                                                            {prop.name}
                                                        </div>
                                                    )
                                                })

                                            }
                                            {
                                                this._filterIndustries(this.state.search).filter((item) => {
                                                    return item.name.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                                }).length < 1 && this.state.dropdown &&
                                                <div onMouseDown={() => this.setState({keyword: true})}
                                                     className={Styles.sectionOneRightIndustryDropdownItemExtra}>
                                                    {this._renderText("item_72")}&nbsp;<span
                                                    className={Styles.sectionOneRightIndustryDropdownItemExtraBold}>{this.state.search}</span>? <span
                                                    className={Styles.sectionOneRightIndustryDropdownItemExtraBoldGreen}>{this._renderText("item_73")}</span>
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                                <div className={Styles.sectionOneRightSubtitleMobile}>
                                    {this._renderText("item_4")}
                                </div>
                                <div className={Styles.sectionOneRightSubtitleMobileBold}>
                                    <Typist stdTypingDelay={5} cursor={{show: false}}>
                                        {this._renderText("item_5")}
                                        <Typist.Backspace count={this._renderText("item_5").length} delay={2000}/>
                                        {this._renderText("item_8")}
                                        <Typist.Backspace count={this._renderText("item_8").length} delay={2000}/>
                                        {this._renderText("item_5")}
                                        <Typist.Backspace count={this._renderText("item_5").length} delay={2000}/>
                                        {this._renderText("item_8")}
                                    </Typist>
                                </div>
                            </div>
                        </div>
                        <img className={Styles.backgroundImageMobile}
                             src={require("../../assets/images/figure_mobile_two.png")}/>
                        <div className={Styles.watchVideo}>
                            {this._renderText("item_75")}
                        </div>
                        {
                            marketRegister.code() === "ae" &&
                            <img className={Styles.sectionFiveFigureTwoMobile}
                                 src={require("../../assets/images/AB_iPad_AE_EN.png")}/>
                        }
                        {
                            marketRegister.code() === "se" && langRegister.lang() === "sv" &&
                            <img className={Styles.sectionFiveFigureTwoMobile}
                                 src={require("../../assets/images/AB_iPad_SE_SV.png")}/>
                        }
                        {
                            marketRegister.code() === "se" && langRegister.lang() === "en" &&
                            <img className={Styles.sectionFiveFigureTwoMobile}
                                 src={require("../../assets/images/AB_iPad_SE_EN.png")}/>
                        }
                        <div className={Styles.sectionOneText}>
                            <div className={Styles.sectionFiveContainerItem}>
                                <div className={Styles.sectionFiveContainerItemTitle}>
                                    {this._renderText("item_10")}
                                </div>
                                <div className={Styles.sectionFiveContainerItemSubtitle}>
                                    {this._renderText("item_11")}
                                </div>
                                <div onClick={() => {
                                    this._lisIndustries()
                                }} className={Styles.sectionFiveContainerItemButton}>
                                    {this._renderText("item_12")}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={Styles.sectionFive}>
                    <img className={Styles.sectionFiveFigure} src={require("../../assets/images/figure-seven.png")}/>
                    {
                        marketRegister.code() === "ae" &&
                        <img className={Styles.sectionFiveFigureTwo}
                             src={require("../../assets/images/AB_iPad_AE_EN.png")}/>
                    }
                    {
                        marketRegister.code() === "se" && langRegister.lang() === "sv" &&
                        <img className={Styles.sectionFiveFigureTwo}
                             src={require("../../assets/images/AB_iPad_SE_SV.png")}/>
                    }
                    {
                        marketRegister.code() === "se" && langRegister.lang() === "en" &&
                        <img className={Styles.sectionFiveFigureTwo}
                             src={require("../../assets/images/AB_iPad_SE_EN.png")}/>
                    }
                    <img onClick={() => this._setVideo(true)} className={Styles.sectionFiveFigureThree}
                         src={require("../../assets/images/play.png")}/>
                    <div className={Styles.sectionFiveContainer}>
                        <div className={Styles.sectionFiveContainerItem}>
                            <div className={Styles.sectionFiveContainerItemTitle}>
                                {this._renderText("item_10")}
                            </div>
                            <div className={Styles.sectionFiveContainerItemSubtitle}>
                                {this._renderText("item_11")}
                            </div>
                            <div onClick={() => {
                                this._lisIndustries()
                            }} className={Styles.sectionFiveContainerItemButton}>
                                {this._renderText("item_12")}
                            </div>
                        </div>
                    </div>
                </div>
                <img className={Styles.sectionTwoGreyAngleMobile}
                     src={require("../../assets/images/AB_shadow_angel_mobile_2.png")}/>
                <div className={Styles.sectionTwo}>
                    <img className={Styles.sectionTwoGreyAngle}
                         src={require("../../assets/images/AB_shadow_angel.png")}/>
                    <div className={Styles.sectionTwoContainer}>
                        <div className={Styles.sectionTwoContainerItem}>
                            <div className={Styles.sectionFourContainerItemIconContainer}>
                                <div className={Styles.sectionFourContainerItemIconContainerInner}>
                                    <img src={require("../../assets/images/user_icon_home.png")}
                                         className={Styles.sectionTwoContainerItemIconUser}/>
                                </div>
                            </div>
                            <div className={Styles.sectionTwoContainerItemTitle}>
                                {this._renderText("item_13")}
                                {
                                    marketRegister.code() === "se" &&
                                    <span className={Styles.sectionTwoContainerItemTitleBold}>&nbsp;12 SEK&nbsp;</span>
                                }
                                {
                                    marketRegister.code() === "ae" &&
                                    <span className={Styles.sectionTwoContainerItemTitleBold}>&nbsp;4 AED&nbsp;</span>
                                }
                                {this._renderText("item_14")}
                            </div>
                        </div>

                        <div className={Styles.sectionTwoContainerItem}>
                            <div className={Styles.sectionFourContainerItemIconContainer}>
                                <div className={Styles.sectionFourContainerItemIconContainerInner}>
                                    <img src={require("../../assets/images/globe-icon.png")}
                                         className={Styles.sectionTwoContainerItemIconGlobe}/>
                                </div>
                            </div>
                            <div className={Styles.sectionTwoContainerItemTitle}>
                                {this._renderText("item_15")} <span
                                className={Styles.sectionTwoContainerItemTitleBold}>{this._renderText("item_16")}</span> {this._renderText("item_17")}
                            </div>
                        </div>

                        <div className={Styles.sectionTwoContainerItem}>
                            <div className={Styles.sectionFourContainerItemIconContainer}>
                                <div className={Styles.sectionFourContainerItemIconContainerInner}>
                                    <img src={require("../../assets/images/check_icon_home.png")}
                                         className={Styles.sectionTwoContainerItemIconCheck}/>
                                </div>
                            </div>
                            <div className={Styles.sectionTwoContainerItemTitle}>
                                {this._renderText("item_18")}&nbsp;<span
                                className={Styles.sectionTwoContainerItemTitleBold}>{this._renderText("item_20")}</span> {this._renderText("item_19")}
                            </div>
                        </div>

                    </div>
                </div>
                <div className={Styles.sectionThree}>
                    <img className={Styles.sectionThreeShadowTop}
                         src={require("../../assets/images/AB_shadow_horisontal.png")}/>
                    <img className={Styles.sectionThreeShadowTopMobile}
                         src={require("../../assets/images/AB_shadow_horisontal_mobile.png")}/>
                    <div className={Styles.sectionThreeContainer}>
                        <div className={Styles.sectionThreeTitle}>
                            <span
                                className={Styles.sectionThreeTitleBold}>{this._renderText("item_21")}</span> {this._renderText("item_22")}
                        </div>
                        <div className={Styles.sectionThreeContainerBottom}>
                            <div className={Styles.sectionThreeContainerBottomItemText}>
                                {this._renderText("item_23")}
                            </div>
                            <div className={Styles.sectionTwoContainerItem}>
                                <div onClick={() => {
                                    this._lisIndustries()
                                }} className={Styles.sectionThreeContainerBottomItemButton}>
                                    {this._renderText("item_24")}
                                </div>
                            </div>
                        </div>
                    </div>
                    <img className={Styles.sectionThreeShadowBottom}
                         src={require("../../assets/images/AB_shadow_horisontal.png")}/>
                    <img className={Styles.sectionThreeShadowBottomMobile}
                         src={require("../../assets/images/AB_shadow_horisontal_mobile.png")}/>
                </div>
                <div className={Styles.sectionFour}>
                    <div className={Styles.sectionFourContainer}>
                        <div className={Styles.sectionFourContainerItem}>
                            <div className={Styles.sectionFourContainerItemIconContainer}>
                                <div className={Styles.sectionFourContainerItemIconContainerInnerWhite}>
                                    <img src={require("../../assets/images/sheets_icon_home.png")}
                                         className={Styles.sectionTwoContainerItemIcon}/>
                                </div>
                            </div>
                            <div className={Styles.sectionFourContainerItemTitle}>
                                {this._renderText("item_25")}
                            </div>
                            <div className={Styles.sectionFourContainerItemTitleBold}>
                                {this._renderText("item_26")}
                            </div>
                        </div>
                        <div className={Styles.sectionFourContainerItem}>
                            <div className={Styles.sectionFourContainerItemIconContainer}>
                                <div className={Styles.sectionFourContainerItemIconContainerInnerWhite}>
                                    <img src={require("../../assets/images/down_icon_home.png")}
                                         className={Styles.sectionTwoContainerItemIconArrow}/>
                                </div>
                            </div>
                            <div className={Styles.sectionFourContainerItemTitle}>
                                {this._renderText("item_27")}
                            </div>
                            <div className={Styles.sectionFourContainerItemTitleBold}>
                                {this._renderText("item_28")}
                            </div>
                        </div>
                        <div className={Styles.sectionFourContainerItem}>
                            <div className={Styles.sectionFourContainerItemIconContainer}>
                                <div className={Styles.sectionFourContainerItemIconContainerInnerWhite}>
                                    <img src={require("../../assets/images/location_icon_home.png")}
                                         className={Styles.sectionTwoContainerItemIconFlag}/>
                                </div>
                            </div>
                            <div className={Styles.sectionFourContainerItemTitle}>
                                {this._renderText("item_29")}
                            </div>
                            <div className={Styles.sectionFourContainerItemTitleBold}>
                                {this._renderText("item_30")}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={Styles.sectionFiveNew}>
                    <div className={Styles.sectionFiveNewInner}>
                        <div className={Styles.sectionFiveNewContainer}>
                            <div className={Styles.sectionFiveNewTitle}>
                                {this._renderText("item_31")}&nbsp;<span
                                className={Styles.sectionFiveNewTitleBoldGreen}>{this._renderText("item_32")}&nbsp;</span><br/><span
                                className={Styles.sectionFiveNewTitleBold}>{this._renderText("item_34")}</span>
                            </div>
                            <div onClick={() => {
                                this._lisIndustries()
                            }} className={Styles.sectionFiveNewButton}>
                                {this._renderText("item_35")}
                            </div>
                        </div>
                    </div>
                    {
                        marketRegister.code() === "ae" &&
                        <img className={Styles.sectionFiveNewImage}
                             src={require("../../assets/images/Dream_AE_EN.png")}/>
                    }
                    {
                        marketRegister.code() === "se" && langRegister.lang() === "sv" &&
                        <img className={Styles.sectionFiveNewImage}
                             src={require("../../assets/images/Dream_SE_SV.png")}/>
                    }
                    {
                        marketRegister.code() === "se" && langRegister.lang() === "en" &&
                        <img className={Styles.sectionFiveNewImage}
                             src={require("../../assets/images/Dream_SE_EN.png")}/>
                    }
                    {
                        marketRegister.code() === "ae" &&
                        <img className={Styles.sectionFiveNewImageMobile}
                             src={require("../../assets/images/Dream_mobile_on_AE_EN.png")}/>
                    }
                    {
                        marketRegister.code() === "se" && langRegister.lang() === "sv" &&
                        <img className={Styles.sectionFiveNewImageMobile}
                             src={require("../../assets/images/Dream_mobile_on_SE_SV.png")}/>
                    }
                    {
                        marketRegister.code() === "se" && langRegister.lang() === "en" &&
                        <img className={Styles.sectionFiveNewImageMobile}
                             src={require("../../assets/images/Dream_mobile_on_SE_EN.png")}/>
                    }
                </div>
                <div id={"benefits"} className={Styles.sectionNine}>
                    <div className={Styles.sectionNineTitle}>
                        {this._renderText("item_36")}
                    </div>
                    <div className={Styles.sectionNineSubtitle}>
                        {this._renderText("item_37")}
                    </div>
                    {
                        marketRegister.code() === "se" && langRegister.lang() === "sv" &&
                        <img className={Styles.sectionNineImage}
                             src={require("../../assets/images/Savings_Diagram_Desktop_SV.png")}/>
                    }
                    {
                        marketRegister.code() === "se" && langRegister.lang() === "sv" &&
                        <img className={Styles.sectionNineImageMobile}
                             src={require("../../assets/images/Savings_Diagram_Mobile_SV.png")}/>
                    }
                    {
                        marketRegister.code() === "se" && langRegister.lang() === "en" &&
                        <img className={Styles.sectionNineImage}
                             src={require("../../assets/images/Savings_Diagram_Desktop_EN.png")}/>
                    }
                    {
                        marketRegister.code() === "se" && langRegister.lang() === "en" &&
                        <img className={Styles.sectionNineImageMobile}
                             src={require("../../assets/images/Savings_Diagram_Mobile_EN.png")}/>
                    }
                    {
                        marketRegister.code() === "ae" &&
                        <img className={Styles.sectionNineImage}
                             src={require("../../assets/images/Savings_Diagram_Desktop_AE_EN.png")}/>
                    }
                    {
                        marketRegister.code() === "ae" &&
                        <img className={Styles.sectionNineImageMobile}
                             src={require("../../assets/images/Savings_Diagram_Mobile_AE_EN.png")}/>
                    }
                    <div className={Styles.sectionNineRightIndustry}>
                        <input
                            disabled={this.state.isLoading}
                            onFocus={() => {
                                this.setState({dropdown_second: true})
                            }}
                            onBlur={() => this.setState({dropdown_second: false})} value={this.state.search_second}
                            //onChange={(event) => this.setState({search_second: event.target.value})}
                            onChange={(event) => {
                                this.setState({search_second: event.target.value}, () => {
                                    this._updateIndustries(salesChannelRegister.get("market"), langRegister.lang(), this.state.search_second);
                                })
                            }}
                            placeholder={this._renderText("item_6")}
                            className={Styles.sectionOneRightIndustryInput}/>
                        <div onClick={() => {
                            this._lisIndustries()
                        }} className={Styles.inputContainerListButton}>
                            <img className={Styles.inputContainerListButtonIcon}
                                 src={require("../../assets/images/list_icon.svg")}/>
                        </div>
                        <div
                            onClick={() => this._lisIndustries()}
                            className={Styles.sectionOneRightIndustryButton}>
                            {
                                !this.state.isLoading &&
                                <div>{this._renderText("item_7")}</div>
                                ||
                                <BeatLoader size={9} color={'#ffffff'} loading={true}/>
                            }
                        </div>
                        {
                            this.state.dropdown_second && !this.state.isLoading &&
                            <div className={Styles.sectionOneRightIndustryDropdown}>
                                {
                                    this._filterIndustries(this.state.search_second).filter((item) => {
                                        return item.name.toLowerCase().indexOf(this.state.search_second.toLowerCase()) !== -1
                                    }).map((prop, i) => {
                                        return (
                                            <div className={
                                                cx(Styles.sectionOneRightIndustryDropdownItem,
                                                    {
                                                        [Styles.sectionOneRightIndustryDropdownItemActive]: prop.selected,
                                                    })
                                            } key={i} onMouseDown={() => this._selectIndustry(prop)}
                                            >
                                                {prop.name}
                                            </div>
                                        )
                                    })

                                }
                            </div>
                        }
                    </div>
                </div>
                <div className={Styles.sectionSix}>
                    <div className={Styles.sectionSixContainer}>
                        <img src={require("../../assets/images/photograper.jpg")}
                             className={Styles.sectionSixContainerImage}/>
                        <div className={Styles.sectionSixContainerText}>
                            {this._renderText("item_38")}
                            <div className={Styles.sectionSixContainerTextBold}>
                                {this._renderText("item_39")}
                            </div>
                            <div className={Styles.sectionSixContainerTextSmall}>
                                {this._renderText("item_40")}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={Styles.sectionSeven}>
                    <div className={Styles.sectionSevenContainer}>
                        <div className={Styles.sectionSevenContainerText}>
                            {this._renderText("item_41")} <span
                            className={Styles.sectionSevenContainerTextSecond}>{this._renderText("item_42")}</span>
                        </div>
                        <div onClick={() => {
                            this._lisIndustries()
                        }} className={Styles.sectionSevenContainerButton}>
                            {this._renderText("item_43")}
                        </div>
                    </div>
                    <img className={Styles.sectionThreeShadowBottom}
                         src={require("../../assets/images/AB_shadow_horisontal.png")}/>
                    <img className={Styles.sectionThreeShadowBottomMobile}
                         src={require("../../assets/images/AB_shadow_horisontal_mobile.png")}/>
                </div>
                <div id={"features"}>
                    <div className={Styles.sectionEight}>
                        <div className={Styles.sectionEightTitle}>
                            <div className={Styles.sectionEightTitleText}>
                                {this._renderText("item_59")}
                            </div>
                        </div>
                        {
                            langRegister.lang() === "sv" &&
                            <img className={Styles.sectionEightImage}
                                 src={require("../../assets/images/360_Desktop6_SV.png")}/>
                        }
                        {
                            langRegister.lang() === "en" &&
                            <img className={Styles.sectionEightImage}
                                 src={require("../../assets/images/360_Desktop6_EN.png")}/>
                        }
                        <img className={Styles.sectionEightImageMobile}
                             src={require("../../assets/images/figure-section-eight-mobile.png")}/>
                        <div className={Styles.sectionEightText}>
                            {this._renderText("item_44")}
                        </div>
                        <div onClick={() => {
                            this._lisIndustries()
                        }} className={Styles.sectionEightButton}>
                            {this._renderText("item_45")}
                        </div>
                    </div>
                    <div className={Styles.sectionEightMobile}>
                        <div className={Styles.sectionEightTitle}>
                            <div className={Styles.sectionEightTitleText}>
                                {this._renderText("item_59")}
                            </div>
                        </div>
                        <div className={Styles.sectionFourContainerItem}>
                            <div className={Styles.sectionFourContainerItemIconContainer}>
                                <div className={Styles.sectionFourContainerItemIconContainerInner}>
                                    <img src={require("../../assets/images/flag-icon-white.svg")}
                                         className={Styles.sectionTwoContainerItemIconFlag}/>
                                </div>
                            </div>
                            <div className={Styles.sectionFourContainerItemTitleBold}>
                                {this._renderText("item_46")}
                            </div>
                            <div className={Styles.sectionFourContainerItemTitleSmall}>
                                {this._renderText("item_47")}
                            </div>
                        </div>
                        <div className={Styles.sectionFourContainerItem}>
                            <div className={Styles.sectionFourContainerItemIconContainer}>
                                <div className={Styles.sectionFourContainerItemIconContainerInner}>
                                    <img src={require("../../assets/images/AB_icon_checked_white.png")}
                                         className={Styles.sectionTwoContainerItemIconUser}/>
                                </div>
                            </div>
                            <div className={Styles.sectionFourContainerItemTitleBold}>
                                {this._renderText("item_48")}
                            </div>
                            <div className={Styles.sectionFourContainerItemTitleSmall}>
                                {this._renderText("item_49")}
                            </div>
                        </div>
                        <div className={Styles.sectionFourContainerItem}>
                            <div className={Styles.sectionFourContainerItemIconContainer}>
                                <div className={Styles.sectionFourContainerItemIconContainerInner}>
                                    <img src={require("../../assets/images/AB_icon_star_white.png")}
                                         className={Styles.sectionTwoContainerItemIconStar}/>
                                </div>
                            </div>
                            <div className={Styles.sectionFourContainerItemTitleBold}>
                                {this._renderText("item_50")}
                            </div>
                            <div className={Styles.sectionFourContainerItemTitleSmall}>
                                {this._renderText("item_51")}
                            </div>
                        </div>
                        <div className={Styles.sectionFourContainerItem}>
                            <div className={Styles.sectionFourContainerItemIconContainer}>
                                <div className={Styles.sectionFourContainerItemIconContainerInner}>
                                    <img src={require("../../assets/images/globe-icon.png")}
                                         className={Styles.sectionTwoContainerItemIconGlobe}/>
                                </div>
                            </div>
                            <div className={Styles.sectionFourContainerItemTitleBold}>
                                {this._renderText("item_52")}
                            </div>
                            <div className={Styles.sectionFourContainerItemTitleSmall}>
                                {this._renderText("item_53")}
                            </div>
                        </div>
                        <div className={Styles.sectionFourContainerItem}>
                            <div className={Styles.sectionFourContainerItemIconContainer}>
                                <div className={Styles.sectionFourContainerItemIconContainerInner}>
                                    <img src={require("../../assets/images/stack-icon-white.svg")}
                                         className={Styles.sectionTwoContainerItemIcon}/>
                                </div>
                            </div>
                            <div className={Styles.sectionFourContainerItemTitleBold}>
                                {this._renderText("item_54")}
                            </div>
                            <div className={Styles.sectionFourContainerItemTitleSmall}>
                                {this._renderText("item_55")}
                            </div>
                        </div>
                        <div className={cx(Styles.sectionFourContainerItem, Styles.sectionFourContainerItemLast)}>
                            <div className={Styles.sectionFourContainerItemIconContainer}>
                                <div className={Styles.sectionFourContainerItemIconContainerInner}>
                                    <img src={require("../../assets/images/user_icon_home.png")}
                                         className={Styles.sectionTwoContainerItemIconUser}/>
                                </div>
                            </div>
                            <div className={Styles.sectionFourContainerItemTitleBold}>
                                {this._renderText("item_56")}
                            </div>
                            <div className={Styles.sectionFourContainerItemTitleSmall}>
                                {this._renderText("item_57")}
                            </div>
                        </div>
                        <img className={Styles.sectionEightMobileImage}
                             src={require("../../assets/images/AB_landing_dj_mobile.jpg")}/>
                        <div className={Styles.sectionEightMobileText}>
                            <div className={Styles.sectionEightText}>
                                {this._renderText("item_44")}
                            </div>
                            <div onClick={() => {
                                this._lisIndustries()
                            }} className={Styles.sectionEightButton}>
                                {this._renderText("item_45")}
                            </div>
                        </div>
                        <div style={{
                            position: "absolute",
                            left: "0",
                            right: "0",
                            bottom: "0",
                            height: "10px",
                            backgroundColor: "white"
                        }}/>
                    </div>
                </div>
                <HomeSectionsEight props={this.props}/>
                <HomeSectionsNine props={this.props}/>
                <div className={Styles.sectionEleven}>
                    <div className={Styles.sectionElevenTitle}>
                        {this._renderText("item_58")}
                    </div>
                    {
                        langRegister.lang() === "sv" &&
                        <img className={Styles.sectionElevenImage}
                             src={require("../../assets/images/CostOpportunity_Diagram_Desktop_SV.png")}/>
                    }
                    {
                        langRegister.lang() === "sv" &&
                        <img className={Styles.sectionElevenImageMobile}
                             src={require("../../assets/images/CostOpportunity_Diagram_Mobile_SV.png")}/>
                    }
                    {
                        langRegister.lang() === "en" &&
                        <img className={Styles.sectionElevenImage}
                             src={require("../../assets/images/CostOpportunity_Diagram_Desktop_EN.png")}/>
                    }
                    {
                        langRegister.lang() === "en" &&
                        <img className={Styles.sectionElevenImageMobile}
                             src={require("../../assets/images/CostOpportunity_Diagram_Mobile_EN.png")}/>
                    }
                </div>
                <HomeSectionsEleven props={this.props}/>
                <HomeSectionsTwelve/>
                <div className={Styles.sectionFifteen}>
                    <img className={Styles.sectionThreeShadowTop}
                         src={require("../../assets/images/AB_shadow_horisontal.png")}/>
                    <img className={Styles.sectionThreeShadowTopMobile}
                         src={require("../../assets/images/AB_shadow_horisontal_mobile.png")}/>
                    {
                        langRegister.lang() === "sv" &&
                        <img className={Styles.sectionFifteenImage}
                             src={require("../../assets/images/FeaturedIn_Desktop_SV.png")}/>
                    }
                    {
                        langRegister.lang() === "sv" &&
                        <img className={Styles.sectionFifteenImageMobile}
                             src={require("../../assets/images/FeaturedIn_Mobile_SV.png")}/>
                    }
                    {
                        langRegister.lang() === "en" &&
                        <img className={Styles.sectionFifteenImage}
                             src={require("../../assets/images/FeaturedIn_Desktop_EN.png")}/>
                    }
                    {
                        langRegister.lang() === "en" &&
                        <img className={Styles.sectionFifteenImageMobile}
                             src={require("../../assets/images/FeaturedIn_Mobile_EN.png")}/>
                    }
                    <img className={Styles.sectionFifteenDividerMobile}
                         src={require("../../assets/images/Divider_Mobile.png")}/>
                    <img className={Styles.sectionFifteenDivider}
                         src={require("../../assets/images/Divider_Desktop.png")}/>
                    <div id={"howto"} className={Styles.sectionFifteenTitle}>
                        {this._renderText("item_62")}
                    </div>
                    <div className={Styles.sectionFifteenSubtitle}>
                        {this._renderText("item_63")}
                    </div>
                    <img className={Styles.sectionThreeShadowBottom}
                         src={require("../../assets/images/AB_shadow_horisontal.png")}/>
                    <img className={Styles.sectionThreeShadowBottomMobile}
                         src={require("../../assets/images/AB_shadow_horisontal_mobile.png")}/>
                </div>
                <div onClick={() => {
                    this._lisIndustries()
                }} className={Styles.sectionSixteen}>
                    {
                        langRegister.lang() === "sv" &&
                        <img className={Styles.sectionSixteenImage}
                             src={require("../../assets/images/HowToAdbop_Desktop_SV_2.png")}/>
                    }
                    {
                        langRegister.lang() === "sv" &&
                        <img className={Styles.sectionSixteenImageMobile}
                             src={require("../../assets/images/HowToAdbop_Mobile_SV_2.png")}/>
                    }
                    {
                        langRegister.lang() === "en" &&
                        <img className={Styles.sectionSixteenImage}
                             src={require("../../assets/images/HowToAdbop_Desktop_EN_2.png")}/>
                    }
                    {
                        langRegister.lang() === "en" &&
                        <img className={Styles.sectionSixteenImageMobile}
                             src={require("../../assets/images/HowToAdbop_Mobile_EN_2.png")}/>
                    }
                </div>
                <div className={Styles.sectionSevenTeen}>
                    <img style={{top: "-4px"}} className={Styles.sectionThreeShadowTop}
                         src={require("../../assets/images/AB_shadow_horisontal.png")}/>
                    <img className={Styles.sectionThreeShadowTopMobile}
                         src={require("../../assets/images/AB_shadow_horisontal_mobile.png")}/>
                    <div className={Styles.sectionSevenContainer}>
                        <div className={Styles.sectionSevenContainerText}>
                            {this._renderText("item_64")}
                            <div className={Styles.sectionSevenContainerTextSecond}>{this._renderText("item_65")}</div>
                        </div>
                        <div onClick={() => {
                            this._lisIndustries()
                        }} className={Styles.sectionSevenContainerButton}>
                            {this._renderText("item_66")}
                        </div>
                    </div>
                    <img className={Styles.sectionThreeShadowBottom}
                         src={require("../../assets/images/AB_shadow_horisontal.png")}/>
                    <img className={Styles.sectionThreeShadowBottomMobile}
                         src={require("../../assets/images/AB_shadow_horisontal_mobile.png")}/>
                </div>
                <div id={"faq"} className={Styles.sectionEighteen}>
                    <div className={Styles.sectionEighteenTitle}>
                        {this._renderText("item_67")}
                    </div>
                    <div className={Styles.sectionEighteenContainer}>
                        {
                            this.state.accordion.map((item) => {
                                return (
                                    <div className={Styles.sectionEighteenItem}>
                                        <div onClick={() => {
                                            item.height = item.height === 0 ? 'auto' : 0;
                                            this.setState({accordion: this.state.accordion})
                                        }} className={Styles.sectionEighteenItemTitle}>
                                            {item.title}
                                            {
                                                item.height === 0 &&
                                                <img className={Styles.sectionEighteenItemIconPlusIcon}
                                                     src={require("../../assets/images/AB_plus_black.png")}/>
                                            }
                                            {
                                                item.height === "auto" &&
                                                <img className={Styles.sectionEighteenItemIconMinusIcon}
                                                     src={require("../../assets/images/AB_minus_black.png")}/>
                                            }
                                        </div>
                                        <AnimateHeight
                                            duration={100}
                                            height={item.height} // see props documentation bellow
                                        >
                                            <div className={Styles.sectionEighteenItemText}>{item.text}</div>
                                        </AnimateHeight>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className={Styles.sectionSevenTeen}>
                    <img className={Styles.sectionThreeShadowTop}
                         src={require("../../assets/images/AB_shadow_horisontal.png")}/>
                    <img className={Styles.sectionThreeShadowTopMobile}
                         src={require("../../assets/images/AB_shadow_horisontal_mobile.png")}/>
                    <div className={Styles.sectionSevenContainer}>
                        <div className={Styles.sectionSevenContainerText}>
                            {this._renderText("item_68")}
                            <div className={Styles.sectionSevenContainerTextSecond}>{this._renderText("item_69")}</div>
                        </div>
                        <a className={Styles.link} targe={"_self"}
                           href={"mailto:support@adbop.com?Subject=" + this._renderText("item_76")}>
                            <div className={Styles.sectionSevenContainerButton}>
                                {this._renderText("item_70")}
                            </div>
                        </a>
                    </div>
                    <img className={Styles.sectionThreeShadowBottom}
                         src={require("../../assets/images/AB_shadow_horisontal.png")}/>
                    <img className={Styles.sectionThreeShadowBottomMobile}
                         src={require("../../assets/images/AB_shadow_horisontal_mobile.png")}/>
                </div>
                <Footer props={this.props}/>
            </div>
    );
    }

    }

    export default Home;


// WEBPACK FOOTER //
// ./src/pages/home/component.js